module.exports = __webpack_public_path__ + "media/images/demo-conversation-6a27c27bc9398140a0f70891cf835021.png";